/* Get Joy — Superfood Organ Treats PDP (v12). Buy box, gallery, ways-to-use, plan state.
   Prices come from the Liquid config: each variant's Skio plan price by cadence, and its full price.
   First order = plan price minus the checkout function's 44.46% (same math as FDR and the chews),
   so the page matches the cart to the cent. */
(function () {
  var root = document.querySelector('[data-gjt-root]');
  var cfgEl = document.querySelector('[data-gjt-config]');
  if (!root || !cfgEl) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var fmt = function (c) { return '$' + (c / 100).toFixed(2); };
  var setText = function (s, t) { $$(s).forEach(function (el) { if (el.textContent !== t) el.textContent = t; }); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var firstOf = function (renew) { return renew - Math.floor(renew * CFG.trialDiscount / 10000); };
  var withW = function (u, w) { return u ? u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w : ''; };

  var organKeys = Object.keys(CFG.organs || {});
  var offered = $$('[data-gjt-freq]').map(function (b) { return +b.getAttribute('data-gjt-freq'); });
  var uses = $$('[data-gjt-use]');

  var S = { flavor: organKeys[0] || 'liver', size: 'small', qty: 1, use: 0, freq: null, buyType: 'sub', addons: {}, plan: null, sticky: false };

  /* ---------- plan state (quiz) ---------- */
  try {
    var raw = localStorage.getItem('gj_quiz_state_v1');
    if (raw) { var qs = JSON.parse(raw); if (qs && qs.a && qs.a.name && (qs.screen === 'plan' || qs.screen === 'build')) S.plan = qs.a; }
  } catch (e) {}
  if (S.plan) {
    S.plan.name = String(S.plan.name).replace(/[<>&"']/g, '').slice(0, 24);
    var goals = S.plan.goals || [];
    if (goals.indexOf('picky') >= 0) uses.forEach(function (u, i) { if (/topper/i.test(u.getAttribute('data-title'))) S.use = i; });
  }

  function variant() {
    var m = CFG.variants.filter(function (v) { return v.flavor === S.flavor && v.size === S.size && v.qty === S.qty; })[0];
    return m || CFG.variants[0];
  }
  function nearest(wk) {
    if (!offered.length) return wk;
    return offered.reduce(function (best, o) { return Math.abs(o - wk) < Math.abs(best - wk) || (Math.abs(o - wk) === Math.abs(best - wk) && o > best) ? o : best; }, offered[0]);
  }
  function idealWeeks() {
    if (S.qty === 3) return nearest(8);
    if (S.qty === 6) return nearest(12);
    var u = uses[S.use];
    var w = u ? +(u.getAttribute(S.size === 'large' ? 'data-large' : 'data-small')) : 4;
    return nearest(w || 4);
  }
  function weeks() { return S.freq || idealWeeks(); }

  function prices() {
    var v = variant(), wk = weeks();
    var pl = v.plans[String(wk)] || v.plans['4'];
    var renew = pl ? pl.price : v.price;
    var first = firstOf(renew);
    var addonTotal = 0;
    $$('[data-gjt-addon]').forEach(function (b) {
      if (!S.addons[b.getAttribute('data-gjt-addon')]) return;
      var pe = b.parentNode.querySelector('.gjc-ad-price');
      var full = +pe.getAttribute('data-full'), r = +pe.getAttribute('data-renew');
      addonTotal += S.buyType === 'sub' ? firstOf(r) : full;
    });
    return { v: v, wk: wk, full: v.price, renew: renew, first: first, plan: pl, addonTotal: addonTotal, total: (S.buyType === 'sub' ? first : v.price) + addonTotal };
  }

  var sizeShort = function () { return S.size === 'large' ? '16 oz' : '4 oz'; };
  var unitPrice = function (size, qty) {
    var m = CFG.variants.filter(function (v) { return v.flavor === S.flavor && v.size === size && v.qty === qty; })[0];
    return m ? m.price : null;
  };

  function render() {
    var d = prices(), wk = d.wk, wkWord = wk === 1 ? 'week' : wk + ' weeks';
    var O = CFG.organs[S.flavor] || {};
    root.style.setProperty('--gjc-tone', O.color || '#FF64C3');

    $$('[data-gjt-flavor]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-gjt-flavor') === S.flavor ? 'true' : 'false'); });
    $$('[data-gjt-size]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-gjt-size') === S.size ? 'true' : 'false'); });
    $$('[data-gjt-qty]').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-gjt-qty') === S.qty ? 'true' : 'false'); });
    $$('[data-gjt-buytype]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-gjt-buytype') === S.buyType ? 'true' : 'false'); });
    $$('[data-gjt-card]').forEach(function (c) { c.setAttribute('data-on', c.getAttribute('data-gjt-card') === S.buyType ? 'true' : 'false'); });
    $$('[data-gjt-freq]').forEach(function (b) { b.setAttribute('aria-checked', +b.getAttribute('data-gjt-freq') === wk ? 'true' : 'false'); });
    $$('[data-gjt-use]').forEach(function (b, i) { b.setAttribute('aria-pressed', i === S.use ? 'true' : 'false'); });
    $$('[data-gjt-ga]').forEach(function (g) { g.hidden = g.getAttribute('data-gjt-ga') !== S.flavor; });

    // per-bag prices and savings on the quantity cards
    var single = unitPrice(S.size, 1);
    /* R58: per-bag price follows the delivery choice and says which price it is */
    var subOn = S.buyType === 'sub';
    $$('[data-gjt-pbl]').forEach(function (e) { if (e.textContent !== (subOn ? 'per bag, 1st Auto-Ship' : 'per bag, one-time')) e.textContent = subOn ? 'per bag, 1st Auto-Ship' : 'per bag, one-time'; });
    [1, 3, 6].forEach(function (q) {
      var p = unitPrice(S.size, q); if (p == null) return;
      var shown = p;
      if (subOn) {
        var mv = CFG.variants.filter(function (v) { return v.flavor === S.flavor && v.size === S.size && v.qty === q; })[0];
        var mpl = mv && (mv.plans[String(weeks())] || mv.plans['4']);
        if (mpl) shown = firstOf(mpl.price);
      }
      setText('[data-gjt-perbag="' + q + '"]', fmt(Math.round(shown / q)));
      var sv = single ? Math.floor((1 - (p / q) / single) * 100 + 1e-9) : 0;
      var se = $('[data-gjt-save="' + q + '"]'); if (se) { se.hidden = !(sv > 0); se.textContent = 'Save ' + sv + '%'; }
    });

    // bag + ingredient images follow the flavor
    if (O.bag) {
      var bi = $('[data-gjt=bag-img]'); if (bi && bi.getAttribute('data-k') !== S.flavor) { bi.src = withW(O.bag, 900); bi.alt = O.name + ' treats bag'; bi.setAttribute('data-k', S.flavor); }
      var bt = $('[data-gjt=bag-thumb]'); if (bt) bt.src = withW(O.bag, 120);
      var ci = $('[data-gjt=close-img]'); if (ci) ci.style.backgroundImage = "url('" + withW(O.bag, 400) + "')";
      var si = $('[data-gjt=sticky-img]'); if (si) si.style.backgroundImage = "url('" + withW(O.bag, 120) + "')";
    }
    if (O.ing) {
      var ii = $('[data-gjt=ing-img]'); if (ii && ii.getAttribute('data-k') !== S.flavor) { ii.src = withW(O.ing, 900); ii.setAttribute('data-k', S.flavor); }
      var it = $('[data-gjt=ing-thumb]'); if (it) it.src = withW(O.ing, 120);
    }

    var u = uses[S.use], useT = u ? u.getAttribute('data-title') : 'Training reward';
    var ideal = idealWeeks();
    var pNow = subOn ? d.first : d.full, pLbl = subOn ? ' first Auto-Ship order' : ' one-time';
    var bagLine = S.qty === 1
      ? 'One ' + sizeShort() + ' bag · ' + fmt(pNow) + pLbl + ' · lasts ~' + ideal + ' weeks as a ' + useT.toLowerCase()
      : S.qty + ' × ' + sizeShort() + ' bags · ' + fmt(pNow) + pLbl + ' (' + fmt(Math.round(pNow / S.qty)) + ' per bag) · delivery paced to match';
    setText('[data-gjt=bagline]', bagLine);

    setText('[data-gjt=freq-val]', wkWord);
    var rec = $('[data-gjt=freq-rec]'); if (rec) rec.hidden = wk !== ideal;
    setText('[data-gjt=sub-first]', fmt(d.first));
    setText('[data-gjt=sub-was]', fmt(d.full));
    setText('[data-gjt=sub-terms]', 'Then ' + fmt(d.renew) + ' every ' + wkWord + ' (10% off) · skip, pause or cancel anytime');
    setText('[data-gjt=otp-price]', fmt(d.full));
    var label = 'Add treats — ' + fmt(d.total);
    setText('[data-gjt=cta-label]', label);
    setText('[data-gjt=close-cta-label]', label);

    setText('[data-gjt=sticky-sub]', '· ' + S.qty + ' × ' + sizeShort() + ' ' + (O.name || ''));
    setText('[data-gjt=sticky-price]', fmt(S.buyType === 'sub' ? d.first : d.full));
    var was = $('[data-gjt=sticky-was]'); if (was) { was.hidden = S.buyType !== 'sub'; was.textContent = fmt(d.full); }
    setText('[data-gjt=sticky-per]', S.buyType === 'sub' ? '· first order' : '· one-time');

    // know tiles follow the organ's guaranteed analysis
    var ga = $('[data-gjt-ga="' + S.flavor + '"]'), tiles = $$('[data-gjt=know-tiles] .gjc-tile');
    if (ga && tiles.length) {
      $$('.gjc-row', ga).slice(0, 3).forEach(function (r, i) {
        var t = tiles[i]; if (!t) return;
        var sp = r.querySelectorAll('span,strong');
        t.querySelector('strong').textContent = sp[1].textContent;
        t.querySelector('span').textContent = sp[0].textContent.toLowerCase();
      });
    }

    // ways to use
    if (u) {
      setText('[data-gjt=use-title]', useT);
      setText('[data-gjt=use-body]', u.getAttribute('data-body'));
      setText('[data-gjt=use-tip1]', u.getAttribute('data-tip1'));
      setText('[data-gjt=use-tip2]', u.getAttribute('data-tip2'));
      setText('[data-gjt=use-pace]', useT + ' pace: one ' + sizeShort() + ' bag every ' + ideal + ' weeks.');
    }

    // add-ons
    $$('.gjc-ad-price').forEach(function (pe) {
      var full = +pe.getAttribute('data-full'), r = +pe.getAttribute('data-renew');
      pe.textContent = S.buyType === 'sub' ? fmt(firstOf(r)) + ' first bag' : fmt(full);
    });
    $$('[data-gjt-addon]').forEach(function (b) {
      var on = !!S.addons[b.getAttribute('data-gjt-addon')];
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.textContent = on ? '✓ In your order' : 'Add to order';
    });
    var strip = $('[data-gjt=addon-strip]');
    if (strip) {
      var rows = $$('[data-gjt-addon]').filter(function (b) { return S.addons[b.getAttribute('data-gjt-addon')]; });
      strip.hidden = !rows.length;
      strip.innerHTML = rows.length ? '<div class="gjc-eyebrow">Also in your first order</div>' + rows.map(function (b) {
        var pe = b.parentNode.querySelector('.gjc-ad-price');
        return '<div class="gjc-strip-r"><span>' + esc(b.getAttribute('data-name')) + '</span><strong>' + esc(pe.textContent) + '</strong><button type="button" data-gjt-unadd="' + b.getAttribute('data-gjt-addon') + '" aria-label="Remove ' + esc(b.getAttribute('data-name')) + '">×</button></div>';
      }).join('') + '<div class="gjc-strip-t"><span>First order total</span><strong>' + fmt(d.total) + '</strong></div>' : '';
    }
    var rt = $('[data-gjt=routine-total]');
    if (rt) { rt.hidden = !d.addonTotal; setText('[data-gjt=routine-total-t]', 'Added to your first order · total ' + fmt(d.total)); }
    var st = $('[data-gjt=sticky]'); if (st) st.hidden = !S.sticky;
  }

  function renderPlan() {
    var a = S.plan; if (!a) return;
    var bt = $('[data-gjt=buy-title]');
    if (bt) bt.textContent = (bt.getAttribute('data-title-named') || "Choose [name]'s favorite").replace(/\[name\]/g, a.name);
    var chip = $('[data-gjt=profile-chip]');
    if (chip) { chip.hidden = false; $('[data-gjt=profile-line]').innerHTML = '<strong>' + esc(a.name) + '</strong>' + (a.weight ? ' · ' + (+a.weight) + ' lb' : '') + ' · treats'; }
    setText('[data-gjt=sticky-title]', a.name + "'s treats");
    setText('[data-gjt=close-eyebrow]', a.name + "'s bag is ready");
  }

  /* ---------- gallery ---------- */
  var slides = $$('[data-gjt-slide]'), thumbs = $$('[data-gjt-thumb]'), gal = 0;
  /* R54: slides come from admin media; media tagged for another flavor carry data-off and are skipped */
  function galOn(s) { return !s.hasAttribute('data-off'); }
  function showSlide(i, dir) {
    var n = slides.length; if (!n) return;
    dir = dir || 1; i = ((i % n) + n) % n;
    for (var g = 0; g < n && !galOn(slides[i]); g++) i = (((i + dir) % n) + n) % n;
    gal = i;
    var gw = slides[0].closest('[data-gj-gal]');
    if (gw) { var fv = -1; for (var q = 0; q < n; q++) { if (galOn(slides[q])) { fv = q; break; } } gw.toggleAttribute('data-first', gal === fv); }
    slides.forEach(function (s, k) {
      var on = k === gal; s.hidden = !on;
      var vid = s.querySelector('video');
      if (vid) { if (on) { if (!vid.src && vid.getAttribute('data-src')) vid.src = vid.getAttribute('data-src'); } else { try { vid.pause(); } catch (e) {} } }
    });
    thumbs.forEach(function (t, k) { t.setAttribute('aria-pressed', k === gal ? 'true' : 'false'); });
  }
  function galFlavor(key) {
    key = String(key || '').toLowerCase();
    [slides, thumbs].forEach(function (L) { L.forEach(function (el) {
      var f = el.getAttribute('data-flavor'); if (f === null) return;
      if (f && key && f !== key) el.setAttribute('data-off', ''); else el.removeAttribute('data-off');
    }); });
    showSlide(0);
  }


  function scrollToBuy() { var bb = $('[data-gjt-buybox]'); if (bb) bb.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  /* ---------- clicks ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('button, a') : null;
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-gjt-flavor')) { S.flavor = t.getAttribute('data-gjt-flavor'); galFlavor(S.flavor); render(); if (t.classList.contains('gjt-organ')) scrollToBuy(); }
    else if (t.hasAttribute('data-gjt-size')) { S.size = t.getAttribute('data-gjt-size'); S.freq = null; render(); }
    else if (t.hasAttribute('data-gjt-qty')) { S.qty = +t.getAttribute('data-gjt-qty'); S.freq = null; render(); }
    else if (t.hasAttribute('data-gjt-buytype')) { S.buyType = t.getAttribute('data-gjt-buytype'); render(); }
    else if (t.matches('[data-gjt=freq-toggle]')) {
      var chips = $('#gjt-freq-chips'), open = chips.hidden;
      chips.hidden = !open; t.setAttribute('aria-expanded', open ? 'true' : 'false'); t.textContent = open ? 'Done' : 'Change';
      if (S.buyType !== 'sub') { S.buyType = 'sub'; render(); }
    }
    else if (t.hasAttribute('data-gjt-freq')) { S.freq = +t.getAttribute('data-gjt-freq'); S.buyType = 'sub'; render(); }
    else if (t.hasAttribute('data-gjt-use')) { S.use = +t.getAttribute('data-gjt-use'); S.freq = null; render(); }
    else if (t.matches('[data-gjt=cta]')) addToCart(t);
    else if (t.hasAttribute('data-gjt-addon')) { var aid = t.getAttribute('data-gjt-addon'); S.addons[aid] = !S.addons[aid]; render(); }
    else if (t.hasAttribute('data-gjt-unadd')) { S.addons[t.getAttribute('data-gjt-unadd')] = false; render(); }
    else if (t.matches('[data-gjt=to-buy]')) scrollToBuy();
    else if (t.matches('[data-gjt=profile-chip]')) { location.href = '/pages/quiz?retake=1'; }
    else if (t.matches('[data-gjt=gal-prev]')) showSlide(gal - 1, -1);
    else if (t.matches('[data-gjt=gal-next]')) showSlide(gal + 1);
    else if (t.hasAttribute('data-gjt-thumb')) showSlide(+t.getAttribute('data-gjt-thumb'));
    else if (t.classList.contains('gjc-rchip')) {
      var tag = t.getAttribute('data-tag');
      $$('.gjc-rchip').forEach(function (c) { c.setAttribute('aria-pressed', c === t ? 'true' : 'false'); });
      $$('.gjc-rev').forEach(function (r) { r.hidden = !!tag && r.getAttribute('data-tag') !== tag; });
    }
    else if (t.hasAttribute('data-gjt-vid')) {
      var pl = $('[data-gjt=vid-player]'), src = t.getAttribute('data-gjt-vid');
      var already = !pl.hidden && pl.getAttribute('data-src') === src;
      $$('[data-gjt-vid]').forEach(function (v) { v.classList.toggle('is-on', v === t && !already); });
      if (already) { pl.hidden = true; pl.innerHTML = ''; pl.removeAttribute('data-src'); return; }
      pl.setAttribute('data-src', src); pl.hidden = false;
      pl.innerHTML = '<div class="gjc-vp-media"><video src="' + esc(src) + '" autoplay playsinline controls></video><button type="button" data-gjt-vclose aria-label="Close video">×</button></div><div class="gjc-vp-cap"><p>' + esc(t.getAttribute('data-quote') || '') + '</p><strong>' + esc(t.getAttribute('data-who') || '') + '</strong></div>';
    }
    else if (t.hasAttribute('data-gjt-vclose')) { var p2 = $('[data-gjt=vid-player]'); p2.hidden = true; p2.innerHTML = ''; p2.removeAttribute('data-src'); $$('[data-gjt-vid]').forEach(function (v) { v.classList.remove('is-on'); }); }
    else if (t.matches('[data-gjt=founder-play]')) {
      var vsrc = t.getAttribute('data-src'); if (!vsrc) return;
      var vv = document.createElement('video'); vv.src = vsrc; vv.controls = true; vv.autoplay = true; vv.playsInline = true; vv.className = 'gjc-vet-video';
      t.replaceWith(vv);
    }
  });

  /* ---------- cart (add, then open the Rebuy drawer in place) ---------- */
  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    try { if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') window.Rebuy.Cart.fetchCart(); } catch (e) {}
    var trig = document.querySelector('.js-drawer-open-cart');
    if (trig) trig.click(); else window.location.href = '/cart';
  }
  function addToCart(btn) {
    var d = prices();
    var main = { id: d.v.id, quantity: 1, properties: {} };
    if (S.plan) main.properties._dog_name = S.plan.name;
    if (S.buyType === 'sub' && d.plan) main.selling_plan = d.plan.id;
    var items = [main];
    $$('[data-gjt-addon]').forEach(function (b) {
      var vid = +b.getAttribute('data-gjt-addon');
      if (!S.addons[vid]) return;
      var it = { id: vid, quantity: 1 };
      if (S.buyType === 'sub' && d.plan) it.selling_plan = d.plan.id; // Skio plans are shared across products
      items.push(it);
    });
    var orig = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Cart error'); }); return r.json(); })
      .then(function () {
        try { (window.dataLayer = window.dataLayer || []).push({ event: 'gjt_add_to_cart', flavor: S.flavor, size: S.size, bags: S.qty, type: S.buyType, weeks: S.buyType === 'sub' ? d.wk : 0, total: d.total / 100 }); } catch (e) {}
        btn.disabled = false; btn.textContent = '✓ Added to cart';
        setTimeout(function () { btn.innerHTML = orig; render(); }, 3000);
        openCart();
      })
      .catch(function (err) {
        btn.disabled = false; btn.innerHTML = orig; render();
        var el = $('[data-gjt=cart-error]'); if (el) { el.textContent = err.message || 'Something went wrong — please try again.'; el.hidden = false; setTimeout(function () { el.hidden = true; }, 5000); }
      });
  }

  /* ---------- sticky bar ---------- */
  var bb = $('[data-gjt-buybox]'), close = $('.gjc-close'), raf = 0;
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      var past = bb && bb.getBoundingClientRect().bottom < 0;
      var cr = close && close.getBoundingClientRect();
      var atClose = cr && cr.top < window.innerHeight && cr.bottom > 0;
      var stick = !!past && !atClose;
      if (stick !== S.sticky) { S.sticky = stick; var st = $('[data-gjt=sticky]'); if (st) st.hidden = !stick; }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  renderPlan();
  render();
  onScroll();
})();

/* R49 · swipe the product gallery on touch (taps the matching arrow) */
(function () {
  if (window.__gjSwipe) return; window.__gjSwipe = 1;
  document.addEventListener('touchstart', function (e) {
    var s = e.target.closest && e.target.closest('.gjc-gal-stage,.gjx-gal-frame');
    if (!s || e.touches.length > 1) return;
    var x0 = e.touches[0].clientX, y0 = e.touches[0].clientY;
    function end(ev) {
      s.removeEventListener('touchend', end);
      var t = ev.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        var b = s.querySelector(dx < 0 ? '[class*="gal-arrow--next"]' : '[class*="gal-arrow--prev"]');
        if (b) b.click();
      }
    }
    s.addEventListener('touchend', end, { passive: true });
  }, { passive: true });
})();
